import React from 'react';
import { WifiZero, WifiLow, WifiHigh, Wifi } from 'lucide-react';
import { getScenarios } from './utils/scenarios';
import type { ScenarioResult } from '../../types';
import { formatCurrency, formatPercent } from './utils/formatters';

interface ScenarioCardsProps {
  results: ScenarioResult;
}

const getStrategyIcon = (riskLevel: number) => {
  switch (riskLevel) {
    case 1:
      return WifiZero;    // Conservative
    case 2:
      return WifiLow;     // Very Low Risk
    case 3:
      return WifiHigh;    // Moderate
    case 4:
      return Wifi;        // Higher
    default:
      return WifiZero;
  }
};

export function ScenarioCards({ results }: ScenarioCardsProps) {
  const scenarios = getScenarios(results);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {scenarios.map((scenario) => {
        const Icon = getStrategyIcon(scenario.riskLevel);
        
        return (
          <div 
            key={scenario.name} 
            className={`p-6 rounded-xl ${scenario.bgColor} border ${scenario.borderColor} relative overflow-hidden transition-all duration-300 hover:shadow-lg`}
          >
            <div className="flex items-start gap-4 relative z-10">
              <div className="relative">
                <div className={`${scenario.iconBgColor} rounded-full p-3`}>
                  <Icon className={`h-6 w-6 ${scenario.iconColor}`} />
                </div>
              </div>
              
              <div className="flex-1">
                <h3 className="text-sm font-medium text-gray-500 mb-1">{scenario.name}</h3>
                <p 
                  className="text-2xl font-bold"
                  style={{ color: scenario.color }}
                >
                  {formatCurrency(scenario.value)}
                </p>
              </div>
            </div>
            
            <div className="mt-4 grid grid-cols-2 gap-2 text-sm relative z-10">
              <div>
                <p className="text-gray-500">Total Return</p>
                <p className="font-medium text-gray-900">{formatPercent(scenario.metrics.totalReturn)}</p>
              </div>
              <div>
                <p className="text-gray-500">Annualized</p>
                <p className="font-medium text-gray-900">{formatPercent(scenario.metrics.annualizedReturn)}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}